import script from "./Feedbacks.vue?vue&type=script&lang=ts&setup=true"
export * from "./Feedbacks.vue?vue&type=script&lang=ts&setup=true"

import "./Feedbacks.vue?vue&type=style&index=0&id=58404537&lang=sass"

const __exports__ = script;

export default __exports__